import { render } from "./DiagnosisDetail.vue?vue&type=template&id=afa6669a&scoped=true"
import script from "./DiagnosisDetail.vue?vue&type=script&lang=js"
export * from "./DiagnosisDetail.vue?vue&type=script&lang=js"

import "./DiagnosisDetail.vue?vue&type=style&index=0&id=afa6669a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa6669a"]])

export default __exports__